// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-navigation-caption[data-v-2395668c]{color:var(--color-primary);line-height:44px;list-style-type:none;white-space:nowrap;text-overflow:ellipsis;box-shadow:none !important;user-select:none;pointer-events:none;padding-left:10px;font-weight:bold}.app-navigation-caption[data-v-2395668c]:not(:first-child){margin-top:22px}\n", ""]);
// Exports
module.exports = exports;
